var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("SearchBar", { on: { searchUser: _vm.getSearchResult } }),
      !!_vm.userEditedList
        ? _c(
            "div",
            { staticClass: "user-edited-container" },
            [
              _c("b-table", {
                attrs: {
                  fields: _vm.userEditedListTable,
                  items: _vm.userEditedList,
                  bordered: "",
                  striped: "",
                  hover: "",
                  footClone: ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "actions",
                    fn: function(row) {
                      return [
                        _c(
                          "b-button",
                          {
                            attrs: {
                              size: "sm",
                              variant: "outline-success",
                              target: "_blank",
                              to: {
                                path: "/dashboard/management/" + row.item.id
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n          Edit " +
                                _vm._s(row.item.fullname) +
                                "'s Info\n        "
                            )
                          ]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-547fc3b9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-547fc3b9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/dashboard/management/EditUserPanel.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-547fc3b9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/dashboard/management/EditUserPanel.vue
// module chunks = 0